<template>
  <div id="kanbanmap"></div>
</template>
<script>
var xisaoMarkers = [];
var qingyunMarkers = [];
var ljtMarkers = [];
var gongceMarkers = [];
var perMarkers = [];
var lineGroups = [];
var overlayGroups = [];
var map;
import axios from "axios";
export default {
  data() {
    return {
      point: [113.11, 23.22],
    };
  },
  methods: {
    drawMap() {},
    gMap(point) {
      map = new AMap.Map("kanbanmap", {
        resizeEnable: true,
        center: this.point,
        zoom: 13,
        defaultCursor: "",
      });
      //map.setMapStyle("amap://styles/6bd83b3bf912d2e1c2961f735685146f");
      map.setMapStyle("amap://styles/blue");
      var that = this;
      map.on("complete", function (ev) {
        that.utils.setMap(map);
        //that.weather();
      });
    },
    weather() {
      AMap.plugin("AMap.Weather", function () {
        //创建天气查询实例
        var weather = new AMap.Weather();

        //执行实时天气信息查询
        weather.getLive("深圳市", function (err, data) {
          console.log(err, data);
        });
      });
      AMap.plugin("AMap.Weather", function () {
        //创建天气查询实例
        var weather = new AMap.Weather();

        //执行实时天气信息查询
        weather.getForecast("北京市", function (err, data) {
          console.log(err, data);
        });
      });
    },

    showXisao(data_info) {
      map.remove(xisaoMarkers);
      xisaoMarkers = [];
      var baseSrc = this.axios.platConfig.fileUri + "mapicon/";
      for (var i = 0, marker; i < data_info.length; i++) {
        var direction = 1;
        var angle = data_info[i].directionDegree;
        if (data_info[i].carTypeIcon.indexOf("001") != -1) {
          angle = 0;
        }
        if (data_info[i].carTypeIcon.indexOf("002") != -1) {
          direction = data_info[i].direction;
        }
        var imgsrc =
          baseSrc +
          data_info[i].carTypeIcon +
          "/" +
          4 +
          "/" +
          direction +
          ".gif";
        var icon = new AMap.Icon({
          size: new AMap.Size(26, 26), // 图标尺寸
          image: imgsrc, // Icon的图像
          imageOffset: new AMap.Pixel(0, 0), // 图像相对展示区域的偏移量，适于雪碧图等
          imageSize: new AMap.Size(26, 26), // 根据所设置的大小拉伸或压缩图片
        });

        // 创建覆盖物群组，并将 marker 传给 OverlayGroup
        marker = new AMap.Marker({
          map: map,
          position: [data_info[i].x, data_info[i].y],
          icon: icon,
          offset: new AMap.Pixel(-13, -13),
          zIndex: 1000,
        });
        marker.setLabel({
          content: "<div class='greenlabel'>" + data_info[i].carNo + "</div>",
          offset: new AMap.Pixel(30, 5),
        });

        xisaoMarkers.push(marker);
      }
      map.setFitView();
      //infoWindow.on("close", alert('关闭'));
    },
    showQingyun(data_info) {
      map.remove(qingyunMarkers);
      qingyunMarkers = [];
      var baseSrc = this.axios.platConfig.fileUri + "mapicon/";
      for (var i = 0, marker; i < data_info.length; i++) {
        var angle = data_info[i].directionDegree;
        var direction = 1;
        if (data_info[i].carTypeIcon.indexOf("001") != -1) {
          angle = 0;
        }
        if (data_info[i].carTypeIcon.indexOf("002") != -1) {
          direction = data_info[i].direction;
        }
        var imgsrc =
          baseSrc +
          data_info[i].carTypeIcon +
          "/" +
          4 +
          "/" +
          direction +
          //direction +
          ".gif";
        var icon = new AMap.Icon({
          size: new AMap.Size(26, 26), // 图标尺寸
          image: imgsrc, // Icon的图像
          imageOffset: new AMap.Pixel(0, 0), // 图像相对展示区域的偏移量，适于雪碧图等
          imageSize: new AMap.Size(26, 26), // 根据所设置的大小拉伸或压缩图片
        });

        // 创建覆盖物群组，并将 marker 传给 OverlayGroup
        marker = new AMap.Marker({
          map: map,
          position: [data_info[i].x, data_info[i].y],
          icon: icon,
          offset: new AMap.Pixel(-13, -13),
          zIndex: 1000,
        });
        marker.setLabel({
          content: "<div class='greenlabel'>" + data_info[i].carNo + "</div>",
          offset: new AMap.Pixel(30, 5),
        });

        qingyunMarkers.push(marker);
      }
      map.setFitView();
      //infoWindow.on("close", alert('关闭'));
    },
    showpersons(data_info) {
      map.remove(perMarkers);
      perMarkers = [];
      for (var i = 0, marker; i < data_info.length; i++) {
        var icon = new AMap.Icon({
          size: new AMap.Size(26, 26), // 图标尺寸
          image: "static/person/2/1.gif", // Icon的图像
          imageOffset: new AMap.Pixel(0, 0), // 图像相对展示区域的偏移量，适于雪碧图等
          imageSize: new AMap.Size(26, 26), // 根据所设置的大小拉伸或压缩图片
        });

        // 创建覆盖物群组，并将 marker 传给 OverlayGroup
        marker = new AMap.Marker({
          map: map,
          position: [data_info[i].x, data_info[i].y],
          icon: icon,
          offset: new AMap.Pixel(-13, -13),
          zIndex: 1000,
        });
        marker.setLabel({
          content:
            "<div class='greenlabel'>" + data_info[i].personName + "</div>",
          offset: new AMap.Pixel(30, 5),
        });

        perMarkers.push(marker);
      }

      //infoWindow.on("close", alert('关闭'));
    },

    showWangge(v) {
      map.remove(overlayGroups);
      if (v.length == 0) {
        return;
      }
      var polyArrs = [];

      var paths = [];
      for (var i = 0; i < v.length; i++) {
        var add = [];
        for (const j in v[i].regionList) {
          var dad = [];
          for (const k in v[i].regionList[j]) {
            var dd = v[i].regionList[j][k];
            var small = new AMap.LngLat(dd.x, dd.y);
            dad.push(small);
          }
          add.push(dad);
        }
        paths.push(add);
        // 创建线实例
        var polygon = new AMap.Polygon({
          path: paths[i],
          strokeWeight: 6,
          strokeOpacity: 0.9,
          fillOpacity: 0.4,
          //fillColor: "#309ef8",
          fillColor: "#3ebaf7",
          zIndex: 50,
        });
        polyArrs.push(polygon);
      }
      overlayGroups = new AMap.OverlayGroup(polyArrs);
      map.add(overlayGroups);
      map.setFitView();
    },

    showline(v) {
      map.remove(lineGroups);
      // lineGroups
      var polyArrs = [];
      var paths = [];
      for (let i = 0; i < v.length; i++) {
        var add = [];
        for (const j in v[i].pointList) {
          var dd = v[i].pointList[j];
          var small = new AMap.LngLat(dd.x, dd.y);
          add.push(small);
        }
        paths.push(add);
        // 创建线实例
        var polyline = new AMap.Polyline({
          path: paths[i],
          strokeWeight: 4,
          strokeColor: "#20bb10",
        });
        polyArrs.push(polyline);
      }
      lineGroups = new AMap.OverlayGroup(polyArrs);
      map.add(lineGroups);
      map.setFitView();
    },
    //显示垃圾桶
    showLjt(data_info) {
      map.remove(ljtMarkers);
      ljtMarkers = [];
      for (var i = 0, marker; i < data_info.length; i++) {
        var icon = new AMap.Icon({
          size: new AMap.Size(24, 24), // 图标尺寸
          image: "static/ljt3.png", // Icon的图像
          imageOffset: new AMap.Pixel(0, 0), // 图像相对展示区域的偏移量，适于雪碧图等
          imageSize: new AMap.Size(24, 24), // 根据所设置的大小拉伸或压缩图片
        });

        // 创建覆盖物群组，并将 marker 传给 OverlayGroup
        var marker = new AMap.Marker({
          map: map,
          position: [data_info[i].x, data_info[i].y],
          icon: icon,
          offset: new AMap.Pixel(-12, -12),
          zIndex: 1000,
        });
        marker.setLabel({
          content: "<div class='bluelabel'>" + data_info[i].name + "</div>",
          offset: new AMap.Pixel(26, 6),
        });

        ljtMarkers.push(marker);
      }
      //map.setFitView();
      //infoWindow.on("close", alert('关闭'));
    },
    showGongce(data_info) {
      map.remove(gongceMarkers);
      gongceMarkers = [];
      for (var i = 0, marker; i < data_info.length; i++) {
        var icon = new AMap.Icon({
          size: new AMap.Size(24, 24), // 图标尺寸
          image: "static/gongce.png", // Icon的图像
          imageOffset: new AMap.Pixel(0, 0), // 图像相对展示区域的偏移量，适于雪碧图等
          imageSize: new AMap.Size(24, 24), // 根据所设置的大小拉伸或压缩图片
        });

        // 创建覆盖物群组，并将 marker 传给 OverlayGroup
        var marker = new AMap.Marker({
          map: map,
          position: [data_info[i].x, data_info[i].y],
          icon: icon,
          offset: new AMap.Pixel(-12, -12),
          zIndex: 1000,
        });
        marker.setLabel({
          content: "<div class='greenlabel'>" + data_info[i].name + "</div>",
          offset: new AMap.Pixel(26, 6),
        });

        gongceMarkers.push(marker);
      }
      //map.setFitView();
      //infoWindow.on("close", alert('关闭'));
    },
  },
  mounted() {
    this.gMap();
    //this.getcars();
    //this.getpersons();
    //this.getwangge();
    //this.getline();
  },
};
</script>
<style lang="">
#kanbanmap {
  width: 100%;
  height: calc(100% - 0px);
  background: #ccc;
}
#kanbanmap .bluelabel {
  background: #1a94c5;
  padding: 4px;
}
#kanbanmap .greenlabel {
  background: #15ba12;
  padding: 4px;
}
#kanbanmap .redlabel {
  background: #f34940;
  padding: 4px;
}
</style>



// WEBPACK FOOTER //
// src/components/kanban/control/ecmap.vue